import React from 'react';
import { Col, Row, Collapse } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import Answer from './answer';
import { Rating } from 'react-simple-star-rating';
import { averageRating } from '../../Services/utils';

const QuestionsAndAnswers = ({ questions, updateQuestionRating, isOpen, toggleAccordion }) => {
  const { t } = useTranslation();

  const handleRating = (rate, answerId, questionId) => {
    updateQuestionRating(rate, answerId, questionId); // Assuming updateQuestionRating is a function passed as a prop
  };

  return (
    <>
      {questions?.length > 0 && (
        <>
          <Row style={{ cursor: 'pointer' }} onClick={toggleAccordion}>
            <Col>
              <div className="form-horizontal pt-4">
                <div className="d-flex justify-content-between align-items-center">
                  <h3>
                    <small>
                      <em className={isOpen ? 'fa fa-minus text-primary mr-2' : 'fa fa-plus text-primary mr-2'}></em>
                    </small>
                    <strong>{t('applications.QUESTIONS_AND_ANSWERS')}</strong>
                  </h3>
                  <Rating initialValue={averageRating(questions)} size={25} readonly allowFraction />
                </div>
              </div>
            </Col>
          </Row>
          <Collapse isOpen={isOpen}>
            <Row>
              <Col>
                {questions.map((item, index) => {
                  return (
                    <div key={index} className="pl-2">
                      <Answer key={index} index={index} item={item} onRating={handleRating} />
                    </div>
                  );
                })}
              </Col>
            </Row>
          </Collapse>
        </>
      )}
    </>
  );
};

export default QuestionsAndAnswers;
